import React from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_FEATURES } from '../../appFeatures';

const LoggedOutHome = () => {
  const navigate = useNavigate();

  return (
    <div className="logged-out-home">
      <img
        src={`${process.env.PUBLIC_URL}/1_19_logo.png`}
        alt="1-19"
        className="logged-out-logo"
      />

      <p className="logged-out-tagline">Every Hole. Every Round.</p>

      <div className="logged-out-actions">
        <button
          className="logged-out-signin-btn"
          onClick={() => navigate('/login')}
        >
          SIGN IN
        </button>
        <button
          className="logged-out-create-btn"
          onClick={() => navigate('/login', { state: { mode: 'register' } })}
        >
          Create account
        </button>
      </div>

      <ul className="logged-out-features">
        {APP_FEATURES.map((f) => (
          <li key={f}><span className="feature-dot" /> {f}</li>
        ))}
      </ul>
    </div>
  );
};

export default LoggedOutHome;
